/*下单*/
const TradeModules= r =>require.ensure([], () => r(require('./')), 'TradeModules')
//确认预约首页
const TradeAppointment=r=>require.ensure([], () => r(require('./appointment')), 'TradeAppointment')
//添加体检人
const TradeMedicalMan=r=>require.ensure([], () => r(require('./medicalMan')), 'TradeMedicalMan')
const TradeMedical=r=>require.ensure([], () => r(require('./medicalMan/medical')), 'TradeMedical')
//新增亲友信息
const TradeNewFriends=r=>require.ensure([], () => r(require('./medicalMan/newFriends')), 'TradeNewFriends')
//选择代金券
const TradeVouchers=r=>require.ensure([], () => r(require('./vouchers')), 'TradeVouchers')
const ChoiceVouchers=r=>require.ensure([], () => r(require('./vouchers/choiceVouchers')), 'ChoiceVouchers')
//支付
const TradePay=r=>require.ensure([], () => r(require('./payment')), 'TradePay')
//选择支付方式
const TradePayWait=r=>require.ensure([], () => r(require('./payment/payWait')), 'TradePayWait')
//确认是否支付
const TradePayConfirm=r=>require.ensure([], () => r(require('./payment/payConfirm')), 'TradePayConfirm')
//支付完成
const TradePayDone=r=>require.ensure([], () => r(require('./payment/payDone')), 'TradePayDone')
/* 现场拦截支付*/
const TradePayIntercept = r => require.ensure([], () => r(require('./payIntercept')), 'TradePayIntercept')
/* 真正现场拦截支付*/
const TradePayInterceptReal = r => require.ensure([], () => r(require('./payIntercept/real')), 'TradePayInterceptReal')
/* 现场拦截支付完成*/
const TradePayInterceptFinish = r => require.ensure([], () => r(require('./payIntercept/finish')), 'TradePayInterceptFinish')
/* 现场拦截支付微信h5是否支付确认*/
const TradePayInterceptConfirm = r => require.ensure([], () => r(require('./payIntercept/confirm')), 'TradePayInterceptConfirm')

export default {
  path:'/trade',
  component: TradeModules,
  meta: { title: '确认预约' },
  redirect: '/user/login',
  children: [{
    path: 'hospital/:hid/meal/:mid/appointment',
    name: 'appointment',
    meta: { title: '确认预约' },
    component: TradeAppointment
  },
  {
    path: '/trade/medicalMan',
    name: 'medicalMan',
    meta: { title: '添加体检人' },
    redirect:'/trade/medicalMan/medical',
    component: TradeMedicalMan,
    children:[
      {
        path: 'medical',
        name: 'medical',
        meta: { title: '添加体检人' },
        component: TradeMedical
      },
      {
        path: '/trade/medicalMan/newFriends/:id',
        name: 'newFriends',
        meta: { title: '新增亲友信息' },
        component: TradeNewFriends
      }
    ]
  },{
    path: '/trade/vouchers',
    name: 'vouchers',
    meta: { title: '选择代金券' },
    redirect:'/trade/vouchers/choiceVouchers',
    component: TradeVouchers,
    children:[
      {
        path: 'choiceVouchers',
        name: 'choiceVouchers',
        meta: { title: '选择代金券' },
        component: ChoiceVouchers
      }
    ]
  },{
    path: '/trade/payment',
    name: 'payment',
    meta: { title: '立即支付' },
    redirect:'/trade/payment/payWait',
    component: TradePay,
    children:[
      {
        path: 'payWait',
        name: 'payWait',
        meta: { title: '立即支付' },
        component: TradePayWait
      },
      {
        path: 'payConfirm',
        name: 'payConfirm',
        meta: { title: '支付订单' },
        component: TradePayConfirm
      },
      {
        path: 'payDone',
        name: 'payDone',
        meta: { title: '支付完成' },
        component: TradePayDone
      }
    ]
  },{
    path: '/trade/payIntercept',
    name: 'payIntercept',
    meta: { title: '提交订单' },
    component: TradePayIntercept,
    redirect:'/trade/payIntercept/real',
    children:[
      {
        path: 'real',
        name: 'payInterceptReal',
        meta: { title: '提交订单' },
        component: TradePayInterceptReal
      },
      {
        path: 'finish',
        name: 'payInterceptFinish',
        meta: { title: '支付完成' },
        component: TradePayInterceptFinish
      },
      {
        path: 'confirm',
        name: 'payInterceptconfirm',
        meta: { title: '支付订单' },
        component: TradePayInterceptConfirm
      }
    ]
  }]
}



// WEBPACK FOOTER //
// ./src/views/trade/router.js